<template>
  <div>
    <basic-container>
      <el-form ref="form" :model="projectDynamicForm" disabled>
        <el-form-item label="工程项目名称">
          <div style="display: flex;width:300px;">
            <el-select v-model="projectDynamicForm.projectItem" placeholder="请选择工程项目名称" width="200" disabled>
              <el-option v-for="item in projectItems" :key="item.id" :label="item.name" :value='item.id'></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="工程动态表单">
          <div v-for="(item, index) of dataList" :key="index">
            <el-table :data="item" :span-method="objectSpanMethod" :show-header='true' border
              style="width: 100%; margin-top: 20px">
              <el-table-column prop="clientType" label="预约渠道" align="center" min-width="180">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.clientType" placeholder="请选择服务类目名称" width="300" disabled>
                    <el-option v-for="item in clientTypes" :key="item.value" :label="item.label"
                      :value='item.value'></el-option>
                  </el-select>
                </template>

              </el-table-column>
              <el-table-column prop="projectList" align="center" label="字段名称" min-width="900">

                <template slot-scope="scope">
                  <div v-for="(i, idx) in dataList[index][0].projectList" v-bind:key='idx'>
                    <el-table :data="dataList[index][0].projectList[idx][0].dynamics" :span-method="inSpanMethod" border
                      style="width: 100%; margin-top: 20px">
                      <el-table-column prop="name" label="工程阶段名称" width="120">
                        <template slot-scope="scope">
                          {{ i[0].name }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="fieldName" label="显示名称">
                        <template slot-scope="scope">
                          <el-input type="input" name="fieldName" v-model="scope.row.fieldName"
                            :value="scope.row.fieldName" placeholder="请输入名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="inputType" min-width="150" label="控件类型">
                        <template slot-scope="scope">
                          <el-select name="inputType" v-model="scope.row.inputType" placeholder="请选择控件类型"
                            :value="scope.row.inputType">
                            <el-option v-for="item in inputTypes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="dataSource" min-width="150" label="数据源">
                        <template slot-scope="scope">
                          <el-select name="dataSource" v-model="scope.row.dataSource" placeholder="请选择数据源"
                            :value="scope.row.dataSource">
                            <el-option v-for="item in dataSources" :key="item.id" :label="item.valueName"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="isNull" label="是否为空" width="150">
                        <template slot-scope="scope">
                          <el-radio v-model="scope.row.isNull" label="YES">
                            是
                          </el-radio>
                          <el-radio v-model="scope.row.isNull" label="NO">
                            否
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column prop="isPay" label="是否计费" width="150">
                        <template slot-scope="scope">
                          <el-radio v-model="scope.row.isPay" label="YES">
                            是
                          </el-radio>
                          <el-radio v-model="scope.row.isPay" label="NO">
                            否
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column prop="amount" label="计费金额">
                        <template slot-scope="scope">
                          <el-input type="input" name="amount" v-model="scope.row.amount"
                            :value="scope.row.amount"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="sort" label="排序">
                        <template slot-scope="scope">
                          <el-input type="input" name="sort" v-model="scope.row.sort"
                            :value="scope.row.sort"></el-input>
                        </template>
                      </el-table-column>
                      <!-- 新增的图片列 -->
                      <el-table-column prop="example" label="示例图片" width="200">
                        <template slot-scope="scope">
                          <image-upload :action="uploadUrl" :inTable="true" :showPlusAndDel="false" :multiple="true" :uploaded-images="scope.row.example"></image-upload>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
        <el-button type="primary" size="small" @click="submit">返回上级</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import {
  findEngineeringProjectAll,
  findEngineeringDynamicDetail,
  findDataSourceAll,
  findDataSourceFields
} from "@/api/work/projectDynamic";

export default {
  data() {
    return {
      projectItems: [],
      projectDynamicForm: {},
      dataList: [],
      clientTypes: DIC.SERVICEITEM_TYPE,
      dataSources: [],
      inputTypes: [],
      isPas: false,
      uploadUrl: '#', // 上传图片的接口地址
    };
  },
  created() {
    this.projectDynamicForm.projectItem = this.$router.currentRoute.query.id;
    findEngineeringDynamicDetail(this.$router.currentRoute.query.id).then(
      res => {
        let data = JSON.parse(res.data);
        let dataList = [];
        for (let i = 0; i < data.projectChannelList.length; i++) {
          let arr = [];
          let obj = {};
          obj.id = data.projectChannelList[i].id;
          obj.clientType = data.projectChannelList[i].clientType;

          let inDataList = [];
          for (
            let j = 0;
            j < data.projectChannelList[i].projectList.length;
            j++
          ) {
            let inarr = [];
            let inobj = {};
            inobj.id = data.projectChannelList[i].projectList[j].id;
            inobj.name = data.projectChannelList[i].projectList[j].name;
            inobj.dynamics = data.projectChannelList[i].projectList[j].dynamics;
            inarr.push(inobj);
            inDataList.push(inarr);
            for (
              let k = 0;
              k < data.projectChannelList[i].projectList[j].dynamics.length;
              k++
            ) {
              data.projectChannelList[i].projectList[j].dynamics[k].inputType =
                data.projectChannelList[i].projectList[j].dynamics[k]
                  .inputType + "";
              data.projectChannelList[i].projectList[j].dynamics[k].example = data.projectChannelList[i].projectList[j].dynamics[k].example || ""; // 确保 example 字段存在
            }
          }
          obj.projectList = inDataList;
          arr.push(obj);
          dataList.push(arr);
        }
        this.dataList = dataList;
      }
    );
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    findEngineeringProjectAll().then(res => {
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
  },
  methods: {
    submit() {
      let item = {
        close: true,
        label: "查看工程动态表单",
        value: "/work/projectDynamic/view"
      };

      if (!this.isPas) {
        this.$store.commit("DEL_TAG", item);
        let obj = {
          value: "/work/projectDynamic",
          label: "工程动态表单管理"
        };
        this.$router.push({
          path: resolveUrlPath(obj.value, obj.label),
          query: obj.query
        });
        this.isPas = true;
      }
    },
    handleSteppingDelete(index, row, idx) {
      //   this.propertiesList.splice(index, 1);
      this.dataList[index][0].projectList[row][0].dynamics.splice(idx, 1);
    },
    handle1SteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);
      var isFst;
      if (row.id != "undefined" && row.id != null) {
        isFst = row.id;
      } else {
        isFst = row;
      }
      if (isFst == "设备调试") {
        this.list1["sed"].splice(index, 1);
      } else {
        this.list1["fst"].splice(index, 1);
      }
    },
    handleAddRows(index, row) {
      let list = {
        targetType: "STAGE"
      };
      this.dataList[index][0].projectList[row][0].dynamics.push(list);
    },
    handle1AddRows(index, row) {
      var isFst;
      if (row.id != "undefined" && row.id != null) {
        isFst = row.id;
      } else {
        isFst = row;
      }
      if (isFst == "设备调试") {
        let list = {
          id: "设备调试",
          name: "龙傲天",
          amount1: "0",
          amount2: "0",
          amount3: 0
        };
        this.list1["sed"].unshift(list);
      } else {
        let list = {
          id: "管道安装",
          name: "赵日天",
          amount1: "0",
          amount2: "0",
          amount3: 0
        };
        this.list1["fst"].unshift(list);
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    inSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 9) {
        if (rowIndex % 20 === 0) {
          return {
            rowspan: 20,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style></style>